<template>
    <div>
        <!-- FIRST MESSAGE INFO -->
        <b-row class="mb-3" v-if=" !isCaregiver && !isClient ">

            <b-col>

                Participants:
                <a class="mx-1" target="_blank" :href=" `/business/${message.from_user.role_type}s/${message.from_user.id}` " v-if=" needsLink( message.from_user ) ">{{ message.from_user.name }}</a>
                <a class="mx-1" target="_blank" :href=" `/business/${message.user.role_type}s/${message.user.id}` " v-if=" needsLink( message.user ) ">{{ message.user.name }}</a>
            </b-col>
        </b-row>
        <b-card :header="message.subject"
            :footer="message.footer_text"
            footer-class="text-muted"
        >
          <b-row>
            <b-col class="reply-body">{{ message.body }}</b-col>
          </b-row>
          <b-row class="mt-2" v-for="(attachment, index) in message.attachments" :key="index">
            <b-col class="bg-light p-2 m-2 rounded"><strong>Attachment:</strong> {{ attachment.filename }} <b-btn variant="info" size="sm" class="ml-2" @click="downloadAttachment(attachment)">Download</b-btn> </b-col>
          </b-row>
        </b-card>

        <b-card v-for="reply in replies"
            :footer="reply.footer_text"
            footer-class="text-muted"
            :key="reply.id"
        >
            <b-row>
                <b-col class="reply-body">{{ reply.body }}</b-col>
            </b-row>
            <b-row class="mt-2" v-for="(attachment, index) in reply.attachments" :key="index">
              <b-col class="bg-light p-2 m-2 rounded"><strong>Attachment:</strong> {{ attachment.filename }} <b-btn variant="info" size="sm" class="ml-2" @click="downloadAttachment(attachment)">Download</b-btn> </b-col>
            </b-row>
        </b-card>

        <!-- REPLY FORM -->
        <b-card v-if=" canReply " header="Reply" :footer="locked ? 'This thread has been closed' : null" footer-class="text-muted">

            <b-row>

                <b-col>

                    <b-form @submit.prevent="submit()">

                        <b-form-group label="Message" label-for="body">
                            <b-textarea
                                name="body"
                                :rows="3"
                                v-model="form.body"
                                :disabled='locked || busy'
                                required
                            >
                            </b-textarea>

                            <input-help :form="form" field="body" text=""></input-help>
                        </b-form-group>

                        <b-form-group label="Attachment" label-for="body">
                          <b-form-file
                              v-model="form.attachment"
                              placeholder="Choose a file or drop it here..."
                              drop-placeholder="Drop file here..."
                              multiple
                          ></b-form-file>
                        </b-form-group>

                        <div class="d-flex align-items-center justify-content-between">

                            <b-button type="submit" variant="success" :disabled="locked || busy ">Reply</b-button>

                            <b-form-checkbox v-if=" admin " v-model=" internal " class="ml-2 p-0">Internal</b-form-checkbox>
                        </div>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>

        <!-- ADMIN ACTIONS -->
        <b-row v-if=" !isCarrierManager && admin " class="mb-4">
            <b-col>
                <b-button v-if="showLink"
                          variant="secondary"
                          :href="message.link_href"
                >
                    {{ message.link_text }}
                </b-button>
                <b-button v-if="message.tag != 'jtr'" 
                    variant="info" 
                    :disabled="busy" 
                    @click="tag('jtr')"
                >
                    Flag JTR
                </b-button>
                <b-button v-if="message.tag != 'ltcg'" 
                    variant="info" 
                    :disabled="busy"
                    @click="tag('ltcg')"
                >
                    Flag LTCG
                </b-button>
                <b-button v-if="message.status != 'closed'"
                    variant="danger" 
                    :disabled="busy"
                    @click="updateStatus('closed')"
                >
                    Close Thread
                </b-button>
                <b-button v-if="message.status == 'closed'"
                    variant="success"
                    :disabled="busy"
                    @click="updateStatus('open')"
                >
                    Re-Open Thread
                </b-button>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col>
                <b-button v-if="showLink"
                          variant="secondary"
                          :href="message.link_href"
                >
                    {{ message.link_text }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import UsesRole from '../mixins/UsesRole';

    export default {

        mixins: [ UsesRole ],

        props: {

            thread : {},
            admin  : false,
        },

        data: () => ({

            message : {},
            form    : new Form({

                body       : '',
                attachment : [],
                internal   : false,
            }),
            busy       : false,
            internal   : false,
            updateForm : new Form({

                tag    : '',
                status : '',
            }),
        }),

        computed: {

            canReply(){

                if( this.isCarrierManager && ( [ 'caregiver', 'client' ].includes( this.message.from_user.role_type ) || [ 'caregiver', 'client' ].includes( this.message.user.role_type ) ) ) return false;

                return !this.message.notification;
            },
            locked() {

                return this.message.status == 'closed';
            },

            url() {

                if( this.admin ){

                    return `/${this.controller}/messages/${this.message.id}`;
                } else {

                    return `/messages/${this.message.id}`;
                }
            },

            replies() {

                if( this.admin ) return this.message.replies;

                if( !this.message.replies ) return [];

                return this.message.replies.filter( item => ! item.internal );
            },

            showLink() {

                return ( window.AuthUser && window.AuthUser.id == this.message.user_id ) && this.message.link_href && this.message.link_text;
            }
        },

        methods: {

            needsLink( user ){

                return user && [ 'client', 'caregiver' ].includes( user.role_type );
            },
            downloadAttachment(attachment) {

                let controller = '';
                switch( this.role ){

                    case 'caregiver':
                    case 'client':

                        controller = '';
                        break;
                    default:

                        controller = `${this.controller}/`;
                        break;
                };

                axios({

                    url:          `/${controller}messages/${attachment.id}/attachment`,
                    method:       'GET',
                    responseType: 'blob',

                }).then((response) => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', attachment.filename);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(() => {});
            },

            submit() {

                this.busy = true;

                if( this.form.attachment == null ) this.form.attachment = '';

                this.form.internal = this.internal ? 1 : 0;
                this.form.submit('POST', this.url, true )
                    .then( ({ data }) => {

                        this.message = data.data;
                        this.busy    = false;
                        this.form.reset();
                    })
                    .catch( e => {

                        this.busy = false;
                    })
            },

            tag(tag) {
                this.busy = true;
                this.updateForm.tag = tag;
                this.updateForm.patch(this.url)
                    .then( ({ data }) => {
                        this.message = data.data;
                        this.busy = false;
                    })
                    .catch(e => {
                        this.busy = false;
                    })
            },

            updateStatus(status) {
                this.busy = true;
                this.updateForm.status = status;
                this.updateForm.patch(this.url)
                    .then( ({ data }) => {
                        this.message = data.data;
                        this.busy = false;
                    })
                    .catch(e => {
                        this.busy = false;
                    })
            },
        },

        created() {

            this.message = this.thread;
        },
    }
</script>

<style>
    .reply-body {
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>
